import React from 'react'

export const GroupReservationContext = React.createContext(null);
export const actions = { 
    update: "update", 
    initialize: "initialize", 
    registerTabSave: "registerTabSave", 
    setDirty: "setDirty", 
    setRoomTypes: "setRoomTypes", 
    setHotelParameters: "setHotelParameters", 
    setReservationDefaults: "setReservationDefaults" 
}